import fetch from 'utils/fetch';

export const load = caseId => {
  return fetch(`/pco-manager/aast/cases/${caseId}/study.json`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(r => r.json());
};

export const update = (id, json) => {
  return fetch(`/pco-manager/aast/cases/${id}/study.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json, (key, value) => {
      return value === '' ? undefined : value;
    }),
  });
};

export const getZoneTemplates = caseId => {
  return fetch(`/pco-manager/aast/cases/${caseId}/zone-templates.json`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(r => r.json());
};

export const copyZone = (id, zoneTemplateId) => {
  return fetch(`/pco-manager/aast/cases/${id}/copy-zone.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      zoneTemplateId: parseInt(zoneTemplateId, 10),
    }),
  });
};



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/api/index.js